// extracted by mini-css-extract-plugin
export default {"confirmCardBtn":"lba-z","disabled":"mba-z","label":"nba-z"};